import { useEffect, useState } from "react";

import { clearRetainedManualCheckoutForm } from "@/pages/SubscriptionDashboard/manualCheckoutActionMemory";
import { apiSlice } from "@/store/api/baseApi";
import { useAppDispatch } from "@/store/store";
import { resetNavigationTrail } from "@/vnext/shared/navigationTrailStore";

/** Clear privileged client state whenever the live Firebase identity changes. */
export const useAdminAuthSessionIsolation = (
  firebaseUid: string | null,
): boolean => {
  const dispatch = useAppDispatch();
  const [isolatedFirebaseUid, setIsolatedFirebaseUid] = useState(firebaseUid);
  const isIsolated = isolatedFirebaseUid === firebaseUid;

  useEffect(() => {
    if (isIsolated) return;

    clearRetainedManualCheckoutForm();
    // Only when a known staff member signs out or changes: a page load that
    // restores the same sign-in (null, then a uid) keeps their own trail.
    // The trail's owner check still discards anyone else's.
    if (isolatedFirebaseUid !== null) resetNavigationTrail();
    dispatch(apiSlice.util.resetApiState());
    setIsolatedFirebaseUid(firebaseUid);
  }, [dispatch, firebaseUid, isIsolated, isolatedFirebaseUid]);

  return isIsolated;
};
